import React from 'react';
import PropTypes from 'prop-types';
import { Panel, Button, Alert } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Link } from 'react-router';
import { I18N, ROLES } from '../../../constants';
import AuthorizedComponent from '../../../components/AuthorizedComponent';

const indexFormatter = (cell, row, obj, index) => index + 1;

const RecoveryActionsInfo = ({
    recoveryActions,
    runId,
    abnormalityId,
    abnormalityType,
    isEditable,
    manifestsWereSelected,
    onRecoveryActionClick,
    createLink,
}) => (
    <Panel collapsible defaultExpanded header="Existing recovery actions for abnormality">
        {isEditable &&
            !manifestsWereSelected && (
                <Alert bsStyle="warning" style={{ marginBottom: 20 }}>
                    To create new recovery actions, one or more manifests must be selected in the
                    table above...
                </Alert>
            )}
        <BootstrapTable
            data={recoveryActions}
            maxHeight={500}
            hover
            scrollTop="Top"
            trClassName="clickable"
            options={{
                onRowClick: onRecoveryActionClick,
            }}
        >
            <TableHeaderColumn isKey hidden dataField="recoveryActionId" width="40">
                ID
            </TableHeaderColumn>
            <TableHeaderColumn dataField="recoveryActionId" dataFormat={indexFormatter} width="15">
                #
            </TableHeaderColumn>
            <TableHeaderColumn dataField="name" width="100">
                Name
            </TableHeaderColumn>
            <TableHeaderColumn
                dataField="type"
                dataFormat={type => I18N.RECOVERY_ACTIONS[type]}
                width="100"
            >
                Type
            </TableHeaderColumn>
            <TableHeaderColumn
                dataField="status"
                dataFormat={status => I18N.RECOVERY_ACTION_STATUS[status]}
                width="100"
            >
                Status
            </TableHeaderColumn>
        </BootstrapTable>
        {isEditable &&
            manifestsWereSelected && (
                <AuthorizedComponent
                    requiredRoles={[
                        ROLES.RECOVERY_ACTION_TAP_EDITOR,
                        ROLES.RECOVERY_ACTION_INSERT_MANIFEST_EDITOR,
                        ROLES.RECOVERY_ACTION_PULL_FORWARD_EDITOR,
                        ROLES.RECOVERY_ACTION_SLIDE_EDITOR,
                        ROLES.RECOVERY_ACTION_SPECIAL_EDITOR,
                        ROLES.RECOVERY_ACTION_EMA_EDITOR,
                        ROLES.RECOVERY_ACTION_SMA_EDITOR,
                    ]}
                >
                    <Link
                        to={
                            createLink ||
                            `runs/${runId}/abnormality/${abnormalityType}/${abnormalityId}/recoveryAction/create`
                        }
                    >
                        <Button bsStyle="success" style={{ marginTop: 10 }}>
                            Create recovery action
                        </Button>
                    </Link>
                </AuthorizedComponent>
            )}
    </Panel>
);

RecoveryActionsInfo.propTypes = {
    recoveryActions: PropTypes.array,
    runId: PropTypes.string,
    abnormalityId: PropTypes.string,
    abnormalityType: PropTypes.string,
    isEditable: PropTypes.bool,
    manifestsWereSelected: PropTypes.bool,
    onRecoveryActionClick: PropTypes.func,
    createLink: PropTypes.string,
};

RecoveryActionsInfo.defaultProps = {
    recoveryActions: [],
};

export default RecoveryActionsInfo;
